import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForPersonController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForPersonController.php
* @route '/api/grave-plot/{person}/person'
*/
const SearchGravePlotForPersonController = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchGravePlotForPersonController.url(args, options),
    method: 'get',
})

SearchGravePlotForPersonController.definition = {
    methods: ["get","head"],
    url: '/api/grave-plot/{person}/person',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForPersonController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForPersonController.php
* @route '/api/grave-plot/{person}/person'
*/
SearchGravePlotForPersonController.url = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { person: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { person: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            person: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        person: typeof args.person === 'object'
        ? args.person.id
        : args.person,
    }

    return SearchGravePlotForPersonController.definition.url
            .replace('{person}', parsedArgs.person.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForPersonController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForPersonController.php
* @route '/api/grave-plot/{person}/person'
*/
SearchGravePlotForPersonController.get = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: SearchGravePlotForPersonController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\GravePlot\SearchGravePlotForPersonController::__invoke
* @see app/Http/Controllers/GravePlot/SearchGravePlotForPersonController.php
* @route '/api/grave-plot/{person}/person'
*/
SearchGravePlotForPersonController.head = (args: { person: string | number | { id: string | number } } | [person: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: SearchGravePlotForPersonController.url(args, options),
    method: 'head',
})

export default SearchGravePlotForPersonController